import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, Window508Type } from "../CalmBaseScenario";
import Scenario3 from "./Scenario3";

export default class Scenario3Part5 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	
	chapterIds = {
		
		scenario3_3c_s14: 'CALM - Scenario 3 - 3C - Segment 14'
	}

	constructor(scenario: Scenario3, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario3/calm-scenario3-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario3.parts.level3Part6.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();

	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario3_3c_s14, () =>
			context.segment2Step1NSCReports())
	}

	

	private segment2Step1NSCReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report'
				},
				{
					title: '24 Hour',
					description: 'Nothing to add to report'
				},
				{
					title: 'End of Shift',
					description: 'Nothing to add to report'
				}
			],
			review: {
				text:
					`
				<p class="regular-description-font" style="margin: 0">
				<span style="color: rgb(222, 225, 156)">
				Ensuring that all of your staff are confident in their roles and responsibilities is one of your most 
				important jobs as a Charge Nurse.</span> However, all confident and able nurses were, at one point, new RN 
				graduates like Miranda. <br /><br />

				Often, new graduates lack two key elements that allow them to promote and maintain patient safety: <span style="color: rgb(222, 225, 156)">knowledge 
				of facility policies and job experience.</span> It is a Charge Nurse’s responsibility to provide these elements 
				to all staff members, especially new graduates. <br /><br />

				Providing Miranda with your facility’s policies and procedures on blood transfusions will help guide 
				her through the necessary steps when conducting a transfusion. It is not necessary that she have these 
				steps memorized. Instead, she <span style="color: rgb(222, 225, 156)">must know where to find them. </span>
				That way, she can be prepared when the time comes.<br /><br />

				Miranda’s job experience will only come with time. 	For now, it is important for you and your experienced 
				staff to <span style="color: rgb(222, 225, 156)">help her whenever her confidence is diminished.</span> The more she observes and assists the experienced 
				staff, the more experienced and confident she will become. Remember though, whether it is you or your staff 
				that provides guidance, <span style="color: rgb(222, 225, 156)">your staffing plan needs to accommodate mentoring time.</span>  
				</p>
				`
			},
			reflects: [
				{
					title: 'Where do you find blood transfusion policies at your facility?',
					answer: ''
				},
				{
					title: 'What are the consequences of you providing help or you delegating to an already busy staff member?',
					answer: ''
				},
				{
					title: 'What staffing decisions could you have made to enable support for Miranda?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			var badges = context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].badges;
			for(var indx = 2; indx < badges.length; indx++) {
				badges[indx].isUnlocked = true;
			}
			context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = null;
			context.scenario.gameManager.UiManager.destroyAllInstances();
			context.scenario.unlockNextLevel();
			context.scenario.update508Window(Window508Type.EndLevelUI);
			context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.EndLevelUI, {
				level: context.scenario.currentLevel,
				badges: badges,
				onExitGameClicked: () => {
					context.scenario.exitGame();
				},
				onNextLevelClicked: () => {
					context.scenario.nextLevel();
					context.onDone();
				}
			});
		});
	}
}